import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import NavBarCustom from "../../components/NavBarCustom/NavBarCustom";
import { ScrollTop } from "../../components/ScrollTop/ScrollTop";
import Contact from "../../containers/Contact/Contact";
import Footer from "../../containers/Footer/Footer";
import PortfolioFullByType from "../../containers/PortfolioFullByType/PortfolioFullByType";

import "../../App.css";
import "./PortfolioByTypePage.css";

const PortfolioByTypePage = (props) => {
	let { type } = useParams();
	const { state } = useLocation();
	const { t } = useTranslation();
	const navigate = useNavigate();

	const [projectsFiltered, setProjectsFiltered] = useState([]);
	const [projectsTitle, setProjectsTitle] = useState({});

	const featured = t("portfolio.featured", { returnObjects: true });
	const extra = t("portfolio.extraProjects", { returnObjects: true });
	const projects = featured.concat(extra);

	useEffect(() => {
		let projectsFilter = projects.filter(
			(project) => project["type"] === type.toUpperCase()
		);

		// Reorder the items to put one first
		if (state && state["reorderItem"] && state["firstItemId"]) {
			const firstItem = projects.filter(
				(project) => project["id"] === state["firstItemId"]
			);
			const othersProjects = projects.filter(
				(project) =>
					project["id"] !== state["firstItemId"] &&
					project["type"] === type.toUpperCase()
			);
			projectsFilter = firstItem.concat(othersProjects);
		}

		if (projectsFilter.length > 0) {
			const title = t(
				"portfolio.projectTypeTitles." + projectsFilter[0]["type"],
				{ returnObjects: true }
			);

			setProjectsFiltered(projectsFilter);
			handleTitles(title);
		} else {
			const title = t("portfolio.projectTypeTitles." + type.toUpperCase(), {
				returnObjects: true,
			});

			setProjectsFiltered([]);
			handleTitles(title);
		}

		// Scroll to the top when the component mounts
		window.scrollTo(0, 0);
	}, [navigate]);

	const handleTitles = (title) => {
		setProjectsTitle(title);
	};

	return (
		<div className="portfolio-by-type-page-container navbar-correction">
			{/* META TAGS */}
			{type === "desarrollo-digital" && (
				<Helmet>
					<title>
						Portafolio de Desarrollo Digital | Apps y Soluciones Web a Medida
					</title>
					<meta
						name="description"
						content="Descubre nuestros proyectos de desarrollo digital, desde aplicaciones móviles hasta herramientas web personalizadas que facilitan la vida y conectan personas."
					/>
				</Helmet>
			)}
			{type === "diseno-ux-ui" && (
				<Helmet>
					<title>Portafolio de Diseños Web Creativos | DevAcuarela</title>
					<meta
						name="description"
						content="Conoce nuestros proyectos de diseño UX/UI, creados para pymes y emprendedores. Inspiración para que tu negocio online destaque con estilo propio. Creamos experiencias visuales y funcionales que impulsan negocios y fidelizan clientes."
					/>
				</Helmet>
			)}
			{type === "marketing-digital" && (
				<Helmet>
					<title>
						Portafolio de Marketing Digital y Branding Visual | DevAcuarela
					</title>
					<meta
						name="description"
						content="Conoce nuestros proyectos de diseño UX/UI, creados para pymes y emprendedores. Inspiración para que tu negocio online destaque con estilo propio. Creamos experiencias visuales y funcionales que impulsan negocios y fidelizan clientes."
					/>
				</Helmet>
			)}

			{/* PAGE CODE */}

			<div id="back-to-top-anchor"></div>

			<NavBarCustom actualRef={"portfolio"} />
			<PortfolioFullByType
				data={{
					projects: projectsFiltered,
					title: projectsTitle,
				}}
			/>
			<Contact />
			<Footer />

			<ScrollTop props={props} />
		</div>
	);
};

export default PortfolioByTypePage;
